import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { openMshopEngagementFilters } from 'Helpers/ecommerce'
import { canBuyEngagementFilters } from 'Helpers/mshopHelpers'
import { handleEngagementFiltersLearnMore } from 'Helpers/openHelp'
import {
  Link,
  MESSAGE_BOX_VARIANT_TIP,
  MessageBox,
  Text,
} from 'mailup-web-components'

const EngagementFiltersUpselling: FC = () => {
  const intl = useIntl()

  const handleLearnMore = (): void => {
    handleEngagementFiltersLearnMore(intl.locale)
  }

  const linkLearnMore = (chunks: string[]): any => {
    return <Link onClick={handleLearnMore}>{chunks}</Link>
  }
  const linkBuy = (chunks: string[]): any => {
    return <Link onClick={openMshopEngagementFilters}>{chunks}</Link>
  }
  const title = intl.formatMessage({
    id: 'Load.FiltersList.EngagementUpsellingTitle',
  })
  const description = intl.formatMessage({
    id: 'Load.FiltersList.EngagementUpsellingDescription',
  })
  const learnMoreOrBuy = intl.formatMessage(
    {
      id: 'Load.FiltersList.EngagementUpsellingLearnMoreOrBuy',
    },
    {
      linkLearnMore,
      linkBuy,
    },
  )
  const learnMoreOrContact = intl.formatMessage(
    {
      id: 'Load.FiltersList.EngagementUpsellingLearnMoreOrContact',
    },
    {
      linkLearnMore,
    },
  )
  const upsell = canBuyEngagementFilters() ? learnMoreOrBuy : learnMoreOrContact

  return (
    <MessageBox
      variant={MESSAGE_BOX_VARIANT_TIP}
      title={title}
      data-mu-test='engagement-filters-upsell'
    >
      <Text>
        {description} {upsell}
      </Text>
    </MessageBox>
  )
}

export default EngagementFiltersUpselling
